/**
 * Where the pages of a case's money are. The request of 8 October 2026
 * (fourth). Both sit under Payments, so whoever holds that screen reaches them
 * and nobody else does.
 */

/** The payment summary of one case. */
export function paymentSummaryPath(jobOrderNo: string): string {
  return `/payments/case/${encodeURIComponent(jobOrderNo)}`;
}

/** One doctor's statement: their cases as bills, and their credit. */
export function doctorStatementPath(doctorId: string): string {
  return `/payments/doctor/${encodeURIComponent(doctorId)}`;
}
